
















































import LevelLabel from "@/components/LevelLabel.vue";
import Vue from "vue";
// param types : application , severity , risk-type , date
export default Vue.extend({
  props: ["param"],
  components: { LevelLabel },
});
